import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject, EMPTY } from 'rxjs';

@Injectable()
export class SeedReturnAddProductSliderModelService {
  public addSeedReturnProductSlider: BehaviorSubject<boolean>;
  public seedReturnSidenav: MatSidenav;
  private activeSliderValue: string;
  seedReturnSliderCloseRqt: Subject<boolean>;
  seedReturnModelData: BehaviorSubject<any>;
  existingDataMarketingBrand: BehaviorSubject<string>;

  constructor() {
    this.addSeedReturnProductSlider = new BehaviorSubject(false);
    this.seedReturnModelData = new BehaviorSubject(EMPTY);
    this.seedReturnSliderCloseRqt = new Subject();
    this.existingDataMarketingBrand = new BehaviorSubject(null);
  }

  activeSlider(value: string) {
    this.activeSliderValue = value;

    if (value === 'AddSeedReturnProductSlider') {
      this.addSeedReturnProductSlider.next(true);
      this.seedReturnModelData.next(EMPTY);
      this.seedReturnSidenav.toggle();
    }
  }

  public setSeedReturnSideNav(seedReturnSideNavObj: MatSidenav) {
    this.seedReturnSidenav = seedReturnSideNavObj;
  }

  public seedReturnClose() {
    this.seedReturnModelData.next(EMPTY);
    this.addSeedReturnProductSlider.next(false);
    this.seedReturnSidenav.close();
  }

  public setData<T>(obj: T) {
    this.seedReturnModelData.next(obj);
  }

  public setRequestData<T>(obj: T) {
    this.seedReturnModelData.next(obj);
  }
}
